import { Controller } from "react-hook-form";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import { TextField } from "@material-ui/core";
import { useInputStyles } from "../inputs.styles";
import { AutocompleteProps } from "./autocomplete.props";

export const Autocomplete = (props: AutocompleteProps) => {
  const error = props.error ?? false;
  const limitTags = props.limitTags ?? -1;

  const classes = useInputStyles();

  const { optionLabel = (option: { label: string }) => option.label } = props;

  return (
    <Controller
      control={props.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <div className={classes.wrapper}>
          <label htmlFor={props.name} className={classes.label}>
            {props.label}
          </label>
          <MuiAutocomplete
            {...renderProps.field}
            getOptionLabel={optionLabel}
            getOptionSelected={props.optionSelected}
            id={props.name}
            limitTags={limitTags}
            multiple={props.multiple}
            // MuiAutocomplete crashes if onChange() is not wrapped like this
            onChange={(_, data) => renderProps.field.onChange(data)}
            options={props.options}
            renderInput={(params) => (
              <TextField
                {...params}
                error={error}
                placeholder={
                  (props.multiple && !renderProps.field.value.length) ||
                  (!props.multiple && renderProps.field.value !== "")
                    ? props.label
                    : ""
                }
                InputProps={{
                  ...params.InputProps,
                  ...props.InputProps,
                  startAdornment: (
                    <>
                      {props.InputProps?.startAdornment}
                      {params.InputProps.startAdornment}
                    </>
                  ),
                }}
                variant="outlined"
              />
            )}
            size="small"
          />
        </div>
      )}
    />
  );
};
